<header class="topbar">
  <button
    type="button"
    class="topbar__menu"
    mat-icon-button
    aria-label="Apri il menu"
    matTooltip="Menu"
    (click)="navigazione.alternaMobile()"
  >
    <mat-icon>menu</mat-icon>
  </button>

  <app-breadcrumb class="topbar__briciole" />

  <div class="topbar__azioni">
    <app-toggle-theme />

    <!--
      `iconPositionEnd` serve davvero: Material proietta le `mat-icon` prima
      dell'etichetta a prescindere dall'ordine nel sorgente, e senza questo la
      freccia finisce a sinistra dell'avatar.
    -->
    <button
      type="button"
      class="topbar__utente"
      mat-button
      iconPositionEnd
      [matMenuTriggerFor]="menuUtente"
      aria-label="Menu utente"
    >
      <span class="topbar__iniziali" aria-hidden="true">{{ iniziali }}</span>
      <span class="topbar__nome">{{ nome }}</span>
      <mat-icon class="topbar__freccia">expand_more</mat-icon>
    </button>

    <mat-menu #menuUtente="matMenu" xPosition="before">
      <button type="button" mat-menu-item routerLink="/settings/profile">
        <mat-icon>person</mat-icon>
        <span>Profilo</span>
      </button>
      <button type="button" mat-menu-item (click)="authService.logout()">
        <mat-icon>logout</mat-icon>
        <span>Esci</span>
      </button>
    </mat-menu>
  </div>

  <!--
    Avanzamento del traffico di fondo. Prima ogni chiamata HTTP stendeva un
    velo nero sull'intera applicazione, anche mentre si digitava in un campo
    con l'autocomplete.
  -->
  @if (caricamento.barraAttiva()) {
    <mat-progress-bar class="topbar__avanzamento" mode="indeterminate" aria-label="Caricamento in corso" />
  }
</header>
